/**
 * 全站权限配置
 *
 */
import router from './router/router'
import store from '@/store'
import {validatenull} from '@/util/validate'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import {getStore} from '@/util/store'
import channelDif, {EnumChannelType, isIframe} from '@/util/channelUtil'
import {EnumInsureUrlType} from '@/const/enum'
import {isBxMeidiGuangfu} from './config/env'

NProgress.configure({showSpinner: false})

router.beforeEach(async (to, from, next) => {
	NProgress.start()
	const meta = to.meta || {}
	console.log('window.location.hostname', isIframe(), window.location.hostname, store.getters.access_token)
	let {
		token = '',
		refreshToken = '',
		secretType123 = '',
		fromTypeChannel = '',
		fromType: fromTypeQuery = '',
		mobile = '',
		params = '',
	} = to.query || {}
	//secretType123 万能密码标识
	if (secretType123) {
		//清除token
		store.commit('SET_ACCESS_TOKEN', '')
		next()
	} else if (token && fromTypeChannel) {
		//其他渠道
		store.commit('SET_DIF_CHANNEL_TYPE', channelDif[fromTypeChannel])
		// token 存在
		store.commit('SET_ACCESS_TOKEN', token)
		store.commit('SET_REFRESH_TOKEN', refreshToken)
		if (channelDif[fromTypeChannel].handleUserInfo) {
			//博维的
			let tempUserInfo = getStore({name: 'userInfo'}) || null
			if (!tempUserInfo) {
				await store.dispatch('GetUserInfo')
				await store.dispatch('getInsureTypes')
			}
		}
		next()
		// } else if (fromTypeQuery && mobile) {
	} else if (to.path === '/proxy/index') {
		//其他渠道 params
		if (isBxMeidiGuangfu) {
			store.commit('SET_DIF_CHANNEL_TYPE', channelDif[EnumChannelType.hekang])
		}
		//合康中转页
		console.log('hekang---fromTypeQuery', fromTypeQuery)
		//得触发登录接口，才能跳转
		await store.dispatch('loginByAuthCode', {code: params, state: 'PT', tId: '21'})
		await store.dispatch('getInsureTypes')
		next()
		return
	}

	if (store.getters.access_token) {
		if (store.getters.isLock && to.path !== '/lock') {
			next({path: '/lock'})
		} else if (to.path === '/login') {
			next({path: '/'})
		} else {
			const value = to.query.src || to.fullPath
			let label = to.query.name || to.name

			// 针对外链跳转
			if ((value.includes('http:') || value.includes('https:')) && !value.includes('entryCenterUrl')) {
				window.open(value, '_blank')
				return
			}

			if (meta.isTab !== false && !validatenull(value) && !validatenull(label)) {
				//添加URL，并且改名字
				if (value.includes('entryCenterUrl')) {
					let {fromType = ''} = to.query || {}
					if (fromType === EnumInsureUrlType.change) {
						label = '替换人员'
					}
				}
				store.commit('ADD_TAG', {
					label: label,
					value: value,
					params: to.params,
					query: to.query,
					group: router.$avueRouter.group || [],
				})
			}
			next()
		}
	} else {
		if (meta.isAuth === false) {
			next()
		} else {
			next('/login')
		}
	}
})

router.afterEach(() => {
	NProgress.done()
	let title = store.getters.tag.label
	if (!store.getters.access_token) {
		title = undefined
	}

	router.$avueRouter.setTitle(title)
})
